var React = require('react');

function PadlockRed (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#FF4B4B","strokeWidth":"2","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round"},[React.createElement("rect",{"x":"5","y":"11","width":"15","height":"10","rx":"1","key":0}),React.createElement("path",{"d":"M8 7V3.615C8 3.275 8.448 3 9 3h7c.552 0 1 .276 1 .615V11","key":1})]));
}

PadlockRed.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = PadlockRed;

PadlockRed.default = PadlockRed;
